import supabase from "../../../shared/database/supabase";
import { CostumerRepositoryGet } from "../model/costumer";

export interface getCostumerResponse {
  costumer: CostumerRepositoryGet;
  error?: { message: string };
};


export const getCostumer = async (id: string) => {
    try {
        const { data, error } = await supabase.functions.invoke<getCostumerResponse>("get-costumer", {
            body: JSON.stringify({
                id: id,
            }),
        });
        const responseError = error || (data?.error ? new Error(data.error.message) : null);
        if (responseError) {
            console.error("Error calling get-costumer:", responseError);
            return { costumer: null, error: responseError };
        }
        if (!data?.costumer?.id) {
            return { costumer: null, error: new Error("Cliente não encontrado.") };
        }
        const costumer = data ? {
            id: data.costumer.id,
            name: data.costumer.name,
            address: data.costumer.address,
            phone: data.costumer.phone,
            phone2: data.costumer.phone2,
            email: data.costumer.email,
            email2: data.costumer.email2,
            email3: data.costumer.email3,
            fullAddress: data.costumer.full_address,
            isCompany: data.costumer.is_company,
            pricePerWorkHour: data.costumer.price_per_working_hour,
            language: data.costumer.language,
            createdAt: data.costumer.created_at,
            updatedAt: data.costumer.updated_at,
            priceVersion: data.costumer.price_version,
        } : null;
        return { costumer , error: null };
    } catch (err) {
        console.error("Exception in getCostumer:", err);
        return { costumer: null, error: err instanceof Error ? err : new Error("Erro ao carregar cliente.") };
    }
};
